angular.module('login.change_pass', [
  'security.service',
  'services.utility',
  'ui.bootstrap'])
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state('login-change-pass', {
        url: '/change_password',
          views: {
          header: {
            template: require('../../common/header/header.tpl.html'),
            resolve: {
              user: ["User", "$q", "$timeout", "$state", function (User,$q, $timeout, $state) {
                return User.current(function (user) {
                  if (user._id) {
                    $timeout(function() {
                      $state.go('account')
                    })
                    return $q.reject()
                  }
                  return user
                }).$promise;
              }],
            },
            controller: 'HeaderCtrl'
          },
          main: {
            template: require('./change-pass.tpl.html'),
            controller: 'LoginChangePassCtrl',
            title: 'Update your password ?'
          },
          footer: {
            template: require('../../common/footer/footer.tpl.html'),
            controller: 'FooterCtrl'
          }
        },
      });
  }])
  .controller('LoginChangePassCtrl', ['$scope', '$location', '$log', 'security', 'utility',
    function ($scope, $location, $log, security, utility) {
      // local variable
      var resetSuccess = function (data) {
        $scope.passwordForm.$setPristine();
        $scope.user = {
          email:  $location.search().email,
          token: $location.search().token
        };
        if (data) {
          $scope.alerts.push({
            type: 'info',
            msg: 'Password was changed successfully. Try to login again.'
          });
        } else {
          angular.forEach(data.errors, function (err, index) {
            $scope.alerts.push({
              type: 'danger',
              msg: err
            });
          });
        }
      };
      var resetError = function () {
        $scope.alerts.push({
          type: 'danger',
          msg: 'Reset password error, Please try again'
        });
      };
      // model def
      $scope.user = {
        email:  $location.search().email,
        token: $location.search().token
      };
      $scope.alerts = [];

      // method def
      $scope.hasError = utility.hasError;
      $scope.showError = utility.showError;
      $scope.canSave = utility.canSave;
      $scope.closeAlert = function (ind) {
        $scope.alerts.splice(ind, 1);
      };
      $scope.submit = function () {
        security.changepass($scope.user).then(resetSuccess, resetError);
      };
    }]);



// WEBPACK FOOTER //
// ./client/src/app/login/changepass/change-pass.js